import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { message } from "antd";

export const useFetchEmployeesTimeline = (month) => {
  return useQuery(
    ["getFetchEmployeesTimeline"],
    async (value) => {
      try { 
        const userId = sessionStorage.getItem('id');
        const endpoint = `/api/v1/employeetimeline/list/${month}/${userId}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Employees Timeline.."); 
      }
    }
  );
};


export const UseFetchUpdateEmployeesTimeline = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/employeetimeline`;
      const result = PUT(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Update Employees Timeline..");
    }
  });
};


